export const HUNDRED = 'cem'

const listFrom100To900: string[] = [
    'cento',
    'duzentos',
    'trezentos',
    'quatrocentos',
    'quinhentos',
    'seiscentos',
    'setecentos',
    'oitocentos',
    'novecentos',
]

export const listFrom100To900Female: string[] = [
    'cento',
    'duzentas',
    'trezentas',
    'quatrocentas',
    'quinhentas',
    'seiscentas',
    'setecentas',
    'oitocentas',
    'novecentas',
]

export default listFrom100To900
